"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Uint32 = exports.Uint16 = exports.makeUnsignedInt = exports.Int16 = exports.makeSignedInt = void 0;
const effect_1 = require("effect");
const NAMESPACE = 'Binary';
/**
 * @param size a positive integer
 * @returns a Number schema
 */
const makeSignedInt = (size) => effect_1.Schema.Int.pipe(effect_1.Schema.between(-(2 ** (size - 1)), 2 ** (size - 1) - 1)).annotations({
    identifier: `${NAMESPACE}.makeInt<${size}>`,
    description: `Signed ${size}-bit integer`,
});
exports.makeSignedInt = makeSignedInt;
exports.Int16 = (0, exports.makeSignedInt)(16);
/**
 * @param size a positive integer
 * @returns a Number schema
 */
const makeUnsignedInt = (size) => effect_1.Schema.Int.pipe(effect_1.Schema.between(0, 2 ** size - 1)).annotations({
    identifier: `${NAMESPACE}.makeUint<${size}>`,
    description: `Unsigned ${size}-bit integer`,
});
exports.makeUnsignedInt = makeUnsignedInt;
exports.Uint16 = (0, exports.makeUnsignedInt)(16);
exports.Uint32 = (0, exports.makeUnsignedInt)(32);
//# sourceMappingURL=binary.js.map